import { ReactNode } from 'react';
import { notification } from 'antd';
declare type NoticeType = 'success' | 'error' | 'info' | 'warning';
/**
 * MTools.Tips({ type, title })
 */

const Notify = (type: NoticeType, message: string | ReactNode) => {
  if (!message) return;
  notification[type]({
    type,
    message
  });
};

export default Notify;
